export const MESSAGE_ERROR = 'mnk:message-error';
export const MESSAGE_SUCCESS = 'mnk:message-success';
export const MESSAGE_INFO = 'mnk:message-info';